import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-homepagecomponent',
  templateUrl: './homepagecomponent.component.html',
  styleUrls: ['./homepagecomponent.component.css']
})
export class HomepagecomponentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
